"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedConstants = void 0;
var EmbedConstants;
(function (EmbedConstants) {
    // Default Embed Options
    EmbedConstants.OPTION_STREAMING_URL = 'streamingURL';
    EmbedConstants.OPTION_HIDDEN_ELEMENTS = 'hiddenElements';
    EmbedConstants.OPTION_DISABLED_INPUT = 'disabledInput';
    // Max length of OPTION_HIDDEN_ELEMENTS
    EmbedConstants.MAX_HIDDEN_ELEMENTS_LENGTH = 14;
    // UI Elements
    EmbedConstants.ELEMENT_TOOLBAR = 'toolbar';
    EmbedConstants.ELEMENT_TOOLBAR_CATALOG = 'catalogButton';
    EmbedConstants.ELEMENT_TOOLBAR__WINDOW_SWITCHER = 'windowSwitcherButton';
    EmbedConstants.ELEMENT_TOOLBAR_FILES = 'filesButton';
    EmbedConstants.ELEMENT_TOOLBAR_CLIPBOARD = 'clipboardButton';
    EmbedConstants.ELEMENT_TOOLBAR_COPY_LOCAL = 'copyToLocalButton';
    EmbedConstants.ELEMENT_TOOLBAR_PASTE_REMOTE = 'pasteToRemoteButton';
    EmbedConstants.ELEMENT_TOOLBAR_SETTINGS = 'settingsButton';
    EmbedConstants.ELEMENT_TOOLBAR_MICROPHONE = 'enableMicrophoneButton';
    EmbedConstants.ELEMENT_TOOLBAR_CAMERA = 'enableWebcamButton';
    EmbedConstants.ELEMENT_TOOLBAR_STREAMING_MODE = 'streamingModeButton';
    EmbedConstants.ELEMENT_TOOLBAR_SCREEN_RESOLUTION = 'screenResolutionButton';
    EmbedConstants.ELEMENT_TOOLBAR_REGIONAL_SETTINGS = 'regionalSettingsButton';
    EmbedConstants.ELEMENT_TOOLBAR_FULLSCREEN = 'fullscreenButton';
    EmbedConstants.ELEMENT_TOOLBAR_END_SESSION = 'endSessionButton';
    EmbedConstants.ELEMENT_TOOLBAR_MAIN = 'mainToolbar';
    EmbedConstants.ELEMENT_ALERT = 'alert';
    //Input Events
    var InputListeners;
    (function (InputListeners) {
        InputListeners[InputListeners["KEY_DOWN"] = 0] = "KEY_DOWN";
        InputListeners[InputListeners["KEY_UP"] = 1] = "KEY_UP";
        InputListeners[InputListeners["KEY_PRESS"] = 2] = "KEY_PRESS";
        InputListeners[InputListeners["MOUSE_MOVE"] = 3] = "MOUSE_MOVE";
        InputListeners[InputListeners["MOUSE_DOWN"] = 4] = "MOUSE_DOWN";
        InputListeners[InputListeners["MOUSE_UP"] = 5] = "MOUSE_UP";
        InputListeners[InputListeners["MOUSE_LEAVE"] = 6] = "MOUSE_LEAVE";
        InputListeners[InputListeners["WHEEL"] = 7] = "WHEEL";
        InputListeners[InputListeners["TOUCH_START"] = 8] = "TOUCH_START";
        InputListeners[InputListeners["TOUCH_MOVE"] = 9] = "TOUCH_MOVE";
        InputListeners[InputListeners["TOUCH_END"] = 10] = "TOUCH_END";
        InputListeners[InputListeners["TOUCH_CANCEL"] = 11] = "TOUCH_CANCEL";
    })(InputListeners = EmbedConstants.InputListeners || (EmbedConstants.InputListeners = {}));
    // Available Embed Events
    var Events = /** @class */ (function () {
        function Events() {
        }
        Events.EVENT_API_BRIDGE = 'appstreamAPI';
        Events.EVENT_SESSION_STATE_CHANGED = 'sessionStateChange';
        Events.EVENT_USER_INTERFACE_STATE_CHANGED = 'userInterfaceStateChange';
        Events.EVENT_SESSION_ENDED = 'embedSessionEnded';
        Events.EVENT_SESSION_RESIZE = 'sessionResize';
        Events.EVENT_SESSION_ERROR = 'sessionError';
        Events.EVENT_PARAM_SESSION_STATUS = 'sessionStatus';
        Events.EVENT_PARAM_STATUS = 'status';
        Events.EVENT_PARAM_ERROR = 'error';
        Events.EVENT_SPINNER = 'spinner';
        Events.EVENT_FILE_UPLOAD_PROGRESS = 'fileUploadProgress';
        Events.EVENT_FILE_DOWNLOAD_READY = 'fileDownloadReady';
        Events.EVENT_COPY_FROM_REMOTE = 'copyFromRemote';
        Events.EVENT_SESSION_METRICS = 'sessionMetrics';
        return Events;
    }());
    EmbedConstants.Events = Events;
    // Available Screen Resolutions
    var Resolutions;
    (function (Resolutions) {
        Resolutions["MATCH_LOCAL_DISPLAY"] = "matchLocalDisplay";
        Resolutions["KEEP_REMOTE_SERVER_DISPLAY"] = "keepRemoteServerDisplay";
        Resolutions["SIZE_2560_X_1440"] = "size2560X1440";
        Resolutions["SIZE_1920_X_1080"] = "size1920X1080";
        Resolutions["SIZE_1280_X_720"] = "size1280X720";
        Resolutions["SIZE_1024_X_768"] = "size1024X768";
        Resolutions["SIZE_800_X_600"] = "size800X600";
    })(Resolutions = EmbedConstants.Resolutions || (EmbedConstants.Resolutions = {}));
    // Available Embed Method calls
    EmbedConstants.METHOD_END_SESSION = 'endSession';
    EmbedConstants.METHOD_SEND_KEYS = 'sendKeys';
    EmbedConstants.METHOD_SEND_KEYBOARD_EVENT = 'sendKeyboardEvent';
    EmbedConstants.METHOD_ENTER_FULLSCREEN = 'enterFullscreen';
    EmbedConstants.METHOD_EXIT_FULLSCREEN = 'exitFullscreen';
    EmbedConstants.METHOD_SHOW_SOFTKEYBOARD = 'showSoftkeyboard';
    EmbedConstants.METHOD_HIDE_SOFTKEYBOARD = 'hideSoftkeyboard';
    EmbedConstants.METHOD_LAUNCH_APP = 'launchApp';
    EmbedConstants.METHOD_LAUNCH_APP_SWITCHER = 'launchAppSwitcher';
    EmbedConstants.METHOD_UPDATE_SPINNER_STATE = 'updateSpinnerState';
    EmbedConstants.METHOD_REFRESH_SESSION = 'refreshSession';
    // PerformAction methods
    EmbedConstants.METHOD_SET_MICROPHONE = 'setMicrophone';
    EmbedConstants.METHOD_SET_WEBCAM = 'setWebcam';
    EmbedConstants.METHOD_SET_STREAMING_MODE = 'setStreamingMode';
    EmbedConstants.METHOD_SWITCH_WINDOWS = 'switchWindows';
    EmbedConstants.METHOD_TOGGLE_MULTI_MONITOR = 'toggleMultiMonitor';
    EmbedConstants.METHOD_LIST_FILES = 'listFiles';
    EmbedConstants.METHOD_CREATE_FOLDER = 'createFolder';
    EmbedConstants.METHOD_RENAME_FILE = 'renameFile';
    EmbedConstants.METHOD_DELETE_FILE = 'deleteFile';
    EmbedConstants.METHOD_DOWNLOAD_FILE = 'downloadFile';
    EmbedConstants.METHOD_UPLOAD_FILE = 'uploadFile';
    EmbedConstants.METHOD_SET_SCREEN_RESOLUTION = 'setScreenResolution';
    EmbedConstants.METHOD_PASTE_TO_REMOTE = 'pasteToRemote';
    EmbedConstants.METHOD_LIST_CATALOG = 'listCatalog';
    EmbedConstants.METHOD_SET_KEYBOARD_SETTINGS = 'setKeyboardSettings';
    // Bridge communication
    EmbedConstants.BRIDGE_CLIENT_NAMESPACE = 'appstream.embed.message.client'; //namespace for messages sent FROM portal TO the client (embedded container)
    EmbedConstants.BRIDGE_HOST_NAMESPACE = 'appstream.embed.message.host'; //namespace for messages sent FROM the client (embedded container) TO portal
    //internal methods
    EmbedConstants.METHOD_EMBED_CLIENT_INTERFACE_READY = 'appstreamEmbedClientInterfaceReady';
    EmbedConstants.METHOD_EMBED_OPTIONS = 'appstreamEmbedOptions';
    EmbedConstants.METHOD_UPDATE_USER_INTERFACE_STATE = 'updateUserInterfaceState';
    EmbedConstants.METHOD_UPDATE_SESSION_STATE = 'updateSessionState';
    EmbedConstants.METHOD_SEND_INITIAL_STATE = "sendInitialState"; // As part of the handshake between the embed client and embed service, we want to send the initial state objects.
    EmbedConstants.METHOD_DISCONNECT_SESSION = 'disconnectSession';
    EmbedConstants.METHOD_REPORT_ERROR = 'reportError';
    EmbedConstants.METHOD_FILE_UPLOAD_PROGRESS = 'fileUploadProgress';
    EmbedConstants.METHOD_COPY_FROM_REMOTE = 'copyFromRemote';
    EmbedConstants.METHOD_SESSION_METRICS = 'sessionMetrics';
    EmbedConstants.METHOD_FILE_DOWNLOAD_READY = "fileDownloadReady";
    // Timeout time for setting up the API Bridge
    EmbedConstants.HOST_WAIT_TIMEOUT = 60000;
    // Timeout in milliseconds for customer to send embed options to AppStream
    EmbedConstants.CLIENT_WAIT_TIMEOUT = 60000;
    // Timeout in milliseconds for AppStream to confirm disconnect before we destroy the iFrame.
    EmbedConstants.DISCONNECT_WAIT_TIMEOUT = 1000;
    // Valid file download url regex
    EmbedConstants.FILE_DOWNLOAD_URL_REGEX = '^https:\\/\\/\\w*\\.amazonappstream\\.com';
    var SessionStatus;
    (function (SessionStatus) {
        SessionStatus[SessionStatus["Unknown"] = 0] = "Unknown";
        SessionStatus[SessionStatus["Reserved"] = 1] = "Reserved";
        SessionStatus[SessionStatus["Started"] = 2] = "Started";
        SessionStatus[SessionStatus["Disconnected"] = 3] = "Disconnected";
        SessionStatus[SessionStatus["Ended"] = 4] = "Ended";
    })(SessionStatus = EmbedConstants.SessionStatus || (EmbedConstants.SessionStatus = {}));
    /**
     * This enum exists to communicate reasons for why a session would have ended.
     * There is another enum in photon/app/scripts/commons, Enums.ErrorCode which has an existing list of termination
     * error codes. In the below enum, we should only include enums that are not captured in Enums.ErrorCode.
     */
    var SessionTerminationReason;
    (function (SessionTerminationReason) {
        SessionTerminationReason[SessionTerminationReason["USER_ENDED_SESSION"] = 0] = "USER_ENDED_SESSION";
    })(SessionTerminationReason = EmbedConstants.SessionTerminationReason || (EmbedConstants.SessionTerminationReason = {}));
    var ResponseStatus;
    (function (ResponseStatus) {
        ResponseStatus["SUCCESS"] = "success";
        ResponseStatus["ERROR"] = "error";
    })(ResponseStatus = EmbedConstants.ResponseStatus || (EmbedConstants.ResponseStatus = {}));
    var ErrorMessages;
    (function (ErrorMessages) {
        ErrorMessages.VALIDATION_ERROR = "The input fails to satisfy the constraints specified by an AWS service.";
        ErrorMessages.MISSING_PARAMETER = "A required parameter for the specified action is not supplied.";
        ErrorMessages.INTERNAL_SERVER_ERROR = "The request processing has failed because of an unknown error, exception or failure.";
        ErrorMessages.INVALID_ACTION = "The given action to perform is invalid.";
        ErrorMessages.BRIDGE_NOT_READY = "The AppStream embed is still initializing and not ready to perform this action.";
    })(ErrorMessages = EmbedConstants.ErrorMessages || (EmbedConstants.ErrorMessages = {}));
    var EmbedKeyboardLocation;
    (function (EmbedKeyboardLocation) {
        EmbedKeyboardLocation[EmbedKeyboardLocation["DOM_KEY_LOCATION_STANDARD"] = KeyboardEvent.DOM_KEY_LOCATION_STANDARD] = "DOM_KEY_LOCATION_STANDARD";
        EmbedKeyboardLocation[EmbedKeyboardLocation["DOM_KEY_LOCATION_LEFT"] = KeyboardEvent.DOM_KEY_LOCATION_LEFT] = "DOM_KEY_LOCATION_LEFT";
        EmbedKeyboardLocation[EmbedKeyboardLocation["DOM_KEY_LOCATION_RIGHT"] = KeyboardEvent.DOM_KEY_LOCATION_RIGHT] = "DOM_KEY_LOCATION_RIGHT";
        EmbedKeyboardLocation[EmbedKeyboardLocation["DOM_KEY_LOCATION_NUMPAD"] = KeyboardEvent.DOM_KEY_LOCATION_NUMPAD] = "DOM_KEY_LOCATION_NUMPAD";
    })(EmbedKeyboardLocation = EmbedConstants.EmbedKeyboardLocation || (EmbedConstants.EmbedKeyboardLocation = {}));
    var MessageVersions;
    (function (MessageVersions) {
        MessageVersions.V1 = "1";
        MessageVersions.V2 = "2";
    })(MessageVersions = EmbedConstants.MessageVersions || (EmbedConstants.MessageVersions = {}));
    var ClientVersions;
    (function (ClientVersions) {
        ClientVersions.V1 = "1.0.0";
    })(ClientVersions = EmbedConstants.ClientVersions || (EmbedConstants.ClientVersions = {}));
    var StreamingMode;
    (function (StreamingMode) {
        StreamingMode["BEST_RESPONSIVENESS"] = "bestResponsiveness";
        StreamingMode["BEST_QUALITY"] = "bestQuality";
    })(StreamingMode = EmbedConstants.StreamingMode || (EmbedConstants.StreamingMode = {}));
    EmbedConstants.EMBED_METHODS = Object.freeze({
        END_SESSION: EmbedConstants.METHOD_END_SESSION,
        SEND_KEYS: EmbedConstants.METHOD_SEND_KEYS,
        SEND_KEYBOARD_EVENT: EmbedConstants.METHOD_SEND_KEYBOARD_EVENT,
        ENTER_FULLSCREEN: EmbedConstants.METHOD_ENTER_FULLSCREEN,
        EXIT_FULLSCREEN: EmbedConstants.METHOD_EXIT_FULLSCREEN,
        SHOW_SOFTKEYBOARD: EmbedConstants.METHOD_SHOW_SOFTKEYBOARD,
        HIDE_SOFTKEYBOARD: EmbedConstants.METHOD_HIDE_SOFTKEYBOARD,
        LAUNCH_APP: EmbedConstants.METHOD_LAUNCH_APP,
        LAUNCH_APP_SWITCHER: EmbedConstants.METHOD_LAUNCH_APP_SWITCHER
    });
    EmbedConstants.EMBED_METHODS_V2 = Object.freeze({
        SET_MICROPHONE: EmbedConstants.METHOD_SET_MICROPHONE,
        SET_WEBCAM: EmbedConstants.METHOD_SET_WEBCAM,
        SET_STREAMING_MODE: EmbedConstants.METHOD_SET_STREAMING_MODE,
        SWITCH_WINDOWS: EmbedConstants.METHOD_SWITCH_WINDOWS,
        TOGGLE_MULTI_MONITOR: EmbedConstants.METHOD_TOGGLE_MULTI_MONITOR,
        LIST_FILES: EmbedConstants.METHOD_LIST_FILES,
        CREATE_FOLDER: EmbedConstants.METHOD_RENAME_FILE,
        RENAME_FILE: EmbedConstants.METHOD_CREATE_FOLDER,
        DELETE_FILE: EmbedConstants.METHOD_DELETE_FILE,
        DOWNLOAD_FILE: EmbedConstants.METHOD_DOWNLOAD_FILE,
        UPLOAD_FILE: EmbedConstants.METHOD_UPLOAD_FILE,
        SET_SCREEN_RESOLUTION: EmbedConstants.METHOD_SET_SCREEN_RESOLUTION,
        PASTE_TO_REMOTE: EmbedConstants.METHOD_PASTE_TO_REMOTE,
        LIST_CATALOG: EmbedConstants.METHOD_LIST_CATALOG,
        SET_KEYBOARD_SETTINGS: EmbedConstants.METHOD_SET_KEYBOARD_SETTINGS,
        REFRESH_SESSION: EmbedConstants.METHOD_REFRESH_SESSION
    });
})(EmbedConstants = exports.EmbedConstants || (exports.EmbedConstants = {}));
